import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import './Sidebar.css'
import { FiLogOut } from "react-icons/fi";
import { TbBell, TbLayoutDashboard, TbMessage, TbUserCircle, TbUsers } from "react-icons/tb";
import { userActions } from "../../_actions";
import { useDispatch, useSelector } from "react-redux";
import LogoutModal from "../Modals/LogoutModal";


function Sidebar({ navbarOpen, setNavbarOpen, setHeaderName }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [isLogoutModal, setIsLogoutModal] = useState(false)
  // const user = JSON.parse(window.sessionStorage.getItem("adminuser"));
  // let userAccess = user?.access || "";
  const adminData = useSelector(state => state.users?.adminData);
  let userAccess = adminData?.access || "";
  let admin_type = adminData?.admin_type || "";
  userAccess = userAccess.split(",");

  const onClickMenu = (url) => {
    navigate(url);
    setHeaderName(url)
    setTimeout(() => {
      setNavbarOpen(!navbarOpen);
    }, 150);
  };

  const sidebarData = [
    {
      access: ['add_customer', 'view_customer', 'edit_customer', 'customer_manag'],
      path: "/app/dashboard",
      icon: <TbLayoutDashboard size={24} />,
      sidebarName: "Dashboard ",
    },
    {
      access: ['add_customer', 'view_customer', 'edit_customer', 'customer_manag'],
      path: "/app/customer",
      icon: <TbUsers size={24} />,
      sidebarName: "Customer Management",
    },
    {
      access: ['admin_manag'],
      path: "/app/admin",
      icon: <TbUserCircle size={24} />,
      sidebarName: "Admin Management",
    },
    {
      access: ['sub_admin_manag'],
      path: "/app/sub-admin",
      icon: <TbUserCircle size={24} />,
      sidebarName: "Sub Admin Management",
    },
    // {
    //   access: ["msg_manag"],
    //   path: "/app/message",
    //   icon: <TbMessage size={24} />,
    //   sidebarName: "Message Management",
    // },
    {
      access: ["noti_manag"],

      path: "/app/notification",
      icon: <TbBell size={24} />,
      sidebarName: "Notification Management",
    },


  ];
  const handleLogout = () => {
    setIsLogoutModal(!isLogoutModal)
  }
  const handleLogoutFunction = () => { dispatch(userActions.logout()); }


  return (
    <>
      {/* <button className={`${navbarOpen ? 'hidden' : 'flex'} absolute top-0 left-0 px-5 items-center justify-center border-r border-gray-200 text-gray-500 focus:outline-none focus:bg-gray-800 focus:text-customColor z-50 h-16 lg:hidden`} onClick={() => setNavbarOpen(!navbarOpen)}>
        <RiMenuUnfold3Line /> 
      </button> */}
      <div className={`${navbarOpen ? 'flex' : 'hidden'} bgcolor fixed left-0 inset-y-0 lg:static lg:flex w-64 z-50 flex-col`}>
        <div className="flex flex-col w-64 relative flex-1 h-full max-h-full border border-[#2121211A]/10">
          <div onClick={() => onClickMenu('/app/dashboard')} className="cursor-pointer h-16 flex-shrink-0 px-4 p-2 bgcolor  w-full z-50 flex justify-center item-center text-center">
            <img src="/Images/logo.png" className="png-container" alt="JBC" />
          </div>
          <nav className="overflow-y-auto flex flex-col flex-wrap justify-between relative w-64 z-10 mt-1 h-full overflow-auto shadow shadow-[#BAB6B640]">
            <div className="flex flex-col flex-wrap w-full mx-auto flex-1">
              <div className="relative z-40 flex-1 w-full p-2 ">
                {sidebarData.map((item, index) => {
                  if (!userAccess.some(access => item.access.includes(access))) return null;
                  return (<div
                    key={index}
                    onClick={() => onClickMenu(item.path)}
                    className={`cursor-pointer py-3 my-3 items-center flex space-x-2 px-4 text-sm transition ease-in-out duration-150  ${location.pathname === item.path
                      ? "textcolor bgactive rounded-md font-medium"
                      : "textcolor font-medium"
                      }`}
                  >
                    <span className="group">{item.icon}</span>
                    <span className="text-sm whitespace-nowrap sidebarFont">
                      {item.sidebarName}
                    </span>
                  </div>)
                })}

                {admin_type === "super" &&
                  <div
                    key={"llll"}
                    onClick={() => onClickMenu("/app/message")}
                    className={`cursor-pointer py-3 my-3 items-center flex space-x-2 px-4 text-sm transition ease-in-out duration-150  ${location.pathname === "/app/message"
                      ? "textcolor bgactive rounded-md font-medium"
                      : "textcolor font-medium"
                      }`}
                  >
                    <span className="group"><TbMessage size={24} /></span>
                    <span className="text-sm whitespace-nowrap sidebarFont">
                      {"Message Management"}
                    </span>
                  </div>
                }
              </div>
              <div onClick={handleLogout} className="bottom-16 mx-auto w-full">
                <p className="w-[95%] font-semibold mb-4 ms-1 p-2 text-white rounded-md flex justify-center items-center gap-3 bgactive textcolor cursor-pointer">
                  <span>Logout</span>
                  <FiLogOut className="text-lg" />
                </p>
              </div>
            </div>
          </nav>
        </div>
      </div>
      {
        isLogoutModal && (
          <LogoutModal isOpen={isLogoutModal} closeModal={() => setIsLogoutModal(prevState => !prevState)} logout={handleLogoutFunction} />
        )
      }
    </>
  );
}

export default Sidebar;
